module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am637-0d42647412e08b269387fd88a9c5f090.jpg";